import React, { useEffect, useState } from 'react'
import { AchivementWrapper } from './Styled'

import { useTranslation } from 'react-i18next'
import { Col, Container, Row } from 'react-bootstrap'
// import { Box, HeadingStyled, SpanStyled, TextStyled } from '../../Styled/Elements'
// import { FooterArrow } from '../../../ui/AllImages'
import { serviceMaintaneData } from '../../projectData/Data'
import { Box, HeadingStyled, MainHeading, SpanStyled, TextStyled } from '../../../ui/Elements'
import { ArrowBtn, ArrowBtnBrown } from '../../../ui/AllImages'

const ServiceMaintane = () => {
    const { t } = useTranslation();
    const [activeItem, setActiveItem] = useState(null);

    
    /* useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 991) {
                setActiveItem(0); 
            } else {
                setActiveItem(null); 
            }
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []); */
    useEffect(() => {
        // ✅ Check window size only once on load
        if (window.innerWidth >= 991) {
        setActiveItem(0); // first tab active only on desktop
        } else {
        setActiveItem(null); // none active on mobile
        }
    }, []); // no resize listener here!

    const toggleItem = (index) => {
        setActiveItem(activeItem === index ? null : index);
    };

    return (
        <AchivementWrapper className='common-space serviceArchiveSec'>
            <Container>
                <Row className='item-container'>
                    <Col lg={3} md={12} className='item-container-left'>
                        {
                            serviceMaintaneData.map((list, index) => (
                                <Box>
                                    <Box key={index} className={`item-box mb-2 ${activeItem === index ? 'active-item-box' : ''}`} onClick={() => toggleItem(index)}>
                                        <Box className='navTabNumber'>{list.number}</Box>{t(list.heading)}
                                    </Box>
                                    {activeItem === index && (
                                        <Box className='service-solution-list mobile-view'>
                                            <Box>
                                                <MainHeading className='main-heading mb-3 main-heading-choose' color="var(--secondaryColor)" size="44px">
                                                    {t(list.heading)}
                                                </MainHeading>
                                            </Box>
                                            <Box className=' service-list-container my-4'>
                                                <Box>
                                                    {list.render && list.render(t)}
                                                    {/* {list.list.map((item, itemIndex) => (
                                                        <Box key={itemIndex} className='d-flex align-items-start gap-3 my-3'>
                                                            <Box className='serArrowList'>
                                                                <ArrowBtnBrown />
                                                           </Box>
                                                            <SpanStyled className='mb-0 whyListTxt' color='var(--text2)'>{t(item)}</SpanStyled>
                                                        </Box>
                                                    ))} */}
                                                </Box>
                                            </Box>
                                        </Box>
                                    )}
                                </Box>
                            ))
                        }

                    </Col>
                    
                    <Col className='border-right desktop-view ssd-wrapper' lg={9} md={12}>
                        <Box className='service-solution-data-container' >
                            {serviceMaintaneData.map((list, index) => (
                                <Box key={index} className={`${activeItem === index ? '' : ''}`} >
                                    {activeItem === index && (
                                        <Box className='service-solution-list'>
                                            <Box className='service-content-number'>{list.number2}</Box>
                                            <Box>
                                                <MainHeading className='main-heading mb-3 main-heading-choose' color="var(--secondaryColor)" size="44px">
                                                    {t(list.heading)}
                                                </MainHeading>
                                                {/* <HeadingStyled className='gradient'>  </HeadingStyled> */}
                                                {/* <SpanStyled className='my-2'>{t(list.text)}</SpanStyled> */}
                                            </Box>
                                            <Box className='service-list-container my-4'>
                                                <Box>
                                                    {/* <Box className='d-flex align-items-start gap-3 my-3'> */}
                                                        {list.render && list.render(t)}
                                                    {/* </Box> */}
                                                </Box>
                                            </Box>
                                            
                                            {/* <Box className='service-list-container my-4'>
                                                
                                                <Box>
                                                    {list.list.map((item, itemIndex) => (
                                                        <Box key={itemIndex} className="d-flex align-items-start gap-3 my-3">
                                                            <Box className="serArrowList"><ArrowBtnBrown /></Box>

                                                            
                                                            <SpanStyled className="mb-0" color="var(--text2)">{t(item)}</SpanStyled>
                                                            
                                                        </Box>
                                                    ))} 
                                                    
                                                    

                                                </Box>
                                            </Box>*/}
                                        </Box>
                                    )}
                                </Box>
                            ))}
                        </Box>
                    </Col>
                    {/* {serviceMaintaneData.map((list, index) => {
                        return (
                            <>

                            </>
                        )
                    })} */}
                </Row>
            </Container>
        </AchivementWrapper >
    )
}

export default ServiceMaintane